import {
  AudienceRowCellActions,
  AudienceRowCellDateCreated,
  AudienceRowCellSeedAudience,
  AudienceRowCellStatus,
  SeedAudienceRowCellPlatform
} from 'components/Audiences/Layout';
import type {
  AudienceTableCellRendererProps,
  SeedAudienceTableRowExtraFunctions,
  SeedAudienceTableRowProps
} from 'types/audiences';
import AudienceRowCellAdAccount from '../Layout/AudienceRowCell.AdAccount';

const seedAudiencesRowRenderer = (
  props: AudienceTableCellRendererProps<SeedAudienceTableRowProps> &
    SeedAudienceTableRowExtraFunctions
) => {
  const { row, header } = props;

  if (!header) return null;

  if (header === 'seedAudience') return <AudienceRowCellSeedAudience {...props} />;

  if (header === 'platform') return <SeedAudienceRowCellPlatform {...props} />;

  if (header === 'displayStatus') return <AudienceRowCellStatus {...props} />;

  if (header === 'dateCreated') return <AudienceRowCellDateCreated date={row?.createdAt} />;

  if (header === 'actions') return <AudienceRowCellActions {...props} />;

  if (header === 'adAccount') return <AudienceRowCellAdAccount {...props} />;

  return <div />;
};

export default seedAudiencesRowRenderer;
